'use strict';
jQuery(function($){
	$('body').on('click','nav[tabs] > button',function(){
		var $button = $(this);
		$button.setSelected('active');
		$($button.attr('target')).setSelected('active');
	});

});